var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordUnfilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 3,
    r: 1,
    fill: "#C31C00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 3,
    r: 2.5,
    stroke: "#C31C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48709 0.0844575C2.65116 0.0136113 2.83083 -0.013362 3.00846 0.00618446C3.1861 0.0257309 3.35561 0.0911255 3.50035 0.195951C4.30184 0.780066 4.92592 1.57735 5.45885 2.34028L5.76879 2.79186L6.0612 3.22311C6.34168 3.63262 6.29751 4.18308 5.95882 4.5414L5.88168 4.61573L4.51361 5.63179C4.44769 5.6795 4.40128 5.74946 4.38297 5.82875C4.36466 5.90803 4.3757 5.99127 4.41403 6.06304C4.72397 6.62682 5.27513 7.46548 5.90623 8.09657C6.53732 8.72767 7.41595 9.31529 8.0183 9.66029C8.08374 9.6973 8.15969 9.71133 8.23404 9.70014C8.30838 9.68896 8.37685 9.65321 8.42851 9.59858L8.46988 9.54669L9.36043 8.19124C9.52415 7.97375 9.76568 7.82806 10.0344 7.78466C10.3032 7.74126 10.5783 7.80354 10.8021 7.95843L11.2972 8.30203C12.2046 8.93523 13.0972 9.60349 13.783 10.4814C13.8963 10.6272 13.9684 10.8008 13.9918 10.9839C14.0151 11.1671 13.9887 11.3532 13.9155 11.5227C13.3321 12.8838 11.8357 14.0576 10.2987 14.0008L10.0883 13.9896L9.92491 13.9756L9.74399 13.9545L9.54695 13.9279L9.33308 13.8921L9.10448 13.8473L8.86186 13.7926L8.60521 13.7274L8.33525 13.6495L8.05336 13.5584C6.75891 13.1201 5.11595 12.2576 3.43023 10.5726C1.7445 8.88755 0.882701 7.24389 0.443738 5.94944L0.35258 5.66755L0.275446 5.39759L0.209532 5.14094L0.154837 4.89832L0.11066 4.66972L0.0755991 4.45585L0.0475504 4.25881L0.0272151 4.07789L0.0131907 3.91451L0.00197125 3.70414C-0.0548274 2.16427 1.12392 0.667871 2.48709 0.0844575Z",
    fill: "#130D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordUnfilledIcon);
export default __webpack_public_path__ + "static/media/record-unfilled-icon.9a5915d3199319dacd69779e03c619bc.svg";
export { ForwardRef as ReactComponent };